import RandomNumberGenerator from '../../utils/randomNumberGenerator';

var randomNumberGenerator = new RandomNumberGenerator();

function sortNumber(a, b) {
    return a - b;
}

function getIncrements(amount, time) {

    var timeIncrements = [];
    var amountIncrements = [];

    for (var incrementIndex = 0; incrementIndex < amount; incrementIndex++) {
        timeIncrements.push(randomNumberGenerator.getRandomInclusive(time));
        amountIncrements.push(0);
    }
    timeIncrements.sort(sortNumber);

    var timeCount = timeIncrements.length;
    while (amount > 0) {
        var slot = randomNumberGenerator.getRandomExclusive(timeCount);
        amountIncrements[slot]++
        amount--;
    }

    var returnArray = [[0, 0]];
    var runningPlayers = 0;
    for (var index = 0; index < timeIncrements.length; index++) {
        runningPlayers += amountIncrements[index];
        returnArray.push([runningPlayers, timeIncrements[index]])
    }

    return returnArray;
}

class PlayerChoiceCountHandler {

    getplayerChoices(total, correctAnswer) {
        var shouldWin = randomNumberGenerator.getRandomInclusive(100) > 20
        var weightedAnswer;
        if (shouldWin) {
            weightedAnswer = correctAnswer;
        } else {
            if (correctAnswer === 'higher') {
                weightedAnswer = 'lower'
            } else {
                weightedAnswer = 'higher'
            }
        }

        var otherPlayerCount = total - 1;
        var winningPercentage = (randomNumberGenerator.getRandomInclusive(30) + 60) / 100;
        var higher = 0;
        var lower = 0;

        if (weightedAnswer === 'higher') {
            higher = Math.round(otherPlayerCount * winningPercentage);
            lower = otherPlayerCount - higher;
        } else {
            lower = Math.round(otherPlayerCount * winningPercentage);
            higher = otherPlayerCount - lower;
        }

        return {
            higherIncrements: getIncrements(higher, 10000),
            lowerIncrements: getIncrements(lower, 10000),
            playersLost: correctAnswer === 'higher' ? lower : higher
        };
    }
}

export default PlayerChoiceCountHandler


// WEBPACK FOOTER //
// ./src/components/elimination-game/playerChoiceCountHandler.js